exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".asset-preview.select-item .thumbnail[data-v-2b65e40a]{height:132px}.asset-preview.select-item .thumbnail img[data-v-2b65e40a]{max-height:130px}.asset-preview:hover .card-body .asset-info.stay[data-v-2b65e40a]{opacity:1}", ""]);

// exports
